import { BookingStatus, VehicleExtraType } from '@carvia/ros-client-types';

export const EXTRA_TYPES_FROZEN_AFTER_HANDOVER: VehicleExtraType[] = [
  VehicleExtraType.EXTRA_KM,
  VehicleExtraType.DEDUCTIBLE,
  VehicleExtraType.WINDOW_AND_MOBILITY_INSURANCE,
];

export const areAllExtrasFrozen = (bookingStatus: BookingStatus) =>
  [BookingStatus.CAR_RETURNED, BookingStatus.FINALIZED].includes(bookingStatus);

export const useIsExtraTypeFrozen =
  (
    bookingStatus: BookingStatus,
    isHandover = false,
    customBookedExtras?: Array<{
      customVehicleExtraType?: VehicleExtraType | null;
      isAdditional?: boolean | null;
    }> | null,
  ) =>
  (extraType: VehicleExtraType | null) => {
    if (areAllExtrasFrozen(bookingStatus)) {
      return true;
    }

    if (
      bookingStatus === BookingStatus.HANDED_OVER &&
      !!extraType &&
      EXTRA_TYPES_FROZEN_AFTER_HANDOVER.includes(extraType)
    ) {
      return true;
    }

    return (
      isHandover &&
      !!extraType &&
      extraType !== VehicleExtraType.EXTRA_KM &&
      !!customBookedExtras?.some(
        (customBookedExtra) =>
          customBookedExtra.customVehicleExtraType === extraType && !customBookedExtra.isAdditional,
      )
    );
  };
